export default "__VITE_ASSET__Cnl9ZCG$__"